import { isString } from '@dimjs/lang';

export interface Viewport {
  currRem: number;
}

// 转换特定设备分辨率下的缩放值到屏幕设计稿像素对应PX值
export const dpiPX2px = (d: number | string): string => {
  const { currRem } = fabricViewport();
  return `${(parseFloat(d.toString()) / currRem) * 100}px`;
};

//  转换屏幕实际像素PX值到特定设备分辨率下的缩放值
export const px2DPIpx = (d: number | string): string => {
  const { currRem } = fabricViewport();
  return `${(parseFloat(d.toString()) / 100) * currRem}px`;
};

// 转换750PX下的视觉稿PX尺寸到REM值
export const px2rem = (d: number): string => {
  return `${d / 100}rem`;
};

export const fabricViewport = () => {
  return window['fabricViewport'] as Viewport;
};

/**
 * 数字格式px转rem
 * @param pxValue px值
 * @param defaultValue 默认值
 * @returns
 * ```
 * 1. px、defaultValue如果是字符串，不会进行如何处理
 * 2. px、defaultValue如果是数字，会使用px2rem处理
 * ```
 */
export const numberPx2rem = (pxValue?: string | number, defaultValue?: string | number) => {
  const newDefaultValue = defaultValue
    ? isString(defaultValue)
      ? defaultValue
      : px2rem(defaultValue as number)
    : undefined;
  const newPxValue = pxValue ? (isString(pxValue) ? pxValue : px2rem(pxValue as number)) : undefined;

  return newPxValue || newDefaultValue;
};

/**
 * 数字格式px转DPIpx
 * @param pxValue px值
 * @param defaultValue 默认值
 * @returns
 * ```
 * 1. px、defaultValue如果是字符串，不会进行如何处理
 * 2. px、defaultValue如果是数字，会使用DPIpx处理
 * ```
 */
export const numberPx2DPIpx = (pxValue?: string | number, defaultValue?: string | number) => {
  const newDefaultValue = defaultValue
    ? isString(defaultValue)
      ? defaultValue
      : px2DPIpx(defaultValue as number)
    : undefined;
  const newPxValue = pxValue ? (isString(pxValue) ? pxValue : px2DPIpx(pxValue as number)) : undefined;

  return newPxValue || newDefaultValue;
};
